export const products = [
  {
    id: 1,
    name: '聆聽Pro 3',
    subtitle: '隱形耳道式助聽器',
    price: 35800,
    image: 'https://readdy.ai/api/search-image?query=modern%20invisible%20in%20the%20ear%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality%20close%20up%20shot&width=400&height=400&seq=1&orientation=squarish',
  },
  {
    id: 2,
    name: '富聆Elite X',
    subtitle: '耳掛式智能助聽器',
    price: 49800,
    image: 'https://readdy.ai/api/search-image?query=modern%20behind%20the%20ear%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality%20close%20up%20shot&width=400&height=400&seq=2&orientation=squarish',
  },
  {
    id: 3,
    name: '清晰Plus 5',
    subtitle: '充電式助聽器',
    price: 28800,
    image: 'https://readdy.ai/api/search-image?query=rechargeable%20hearing%20aid%20device%20with%20charging%20dock%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality&width=400&height=400&seq=3&orientation=squarish',
  },
  {
    id: 4,
    name: '守護Mini 2',
    subtitle: '迷你耳內式助聽器',
    price: 42800,
    image: 'https://readdy.ai/api/search-image?query=mini%20in%20the%20ear%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality%20close%20up&width=400&height=400&seq=4&orientation=squarish',
  },
  {
    id: 5,
    name: '聆悅Comfort',
    subtitle: '舒適型耳掛助聽器',
    price: 32800,
    image: 'https://readdy.ai/api/search-image?query=comfortable%20behind%20the%20ear%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality&width=400&height=400&seq=5&orientation=squarish',
  },
  {
    id: 6,
    name: '智能Link Pro',
    subtitle: '藍牙連線助聽器',
    price: 55800,
    image: 'https://readdy.ai/api/search-image?query=bluetooth%20connected%20hearing%20aid%20device%20product%20photography%20on%20soft%20cream%20white%20background%20minimalist%20professional%20lighting%20high%20quality%20close%20up&width=400&height=400&seq=6&orientation=squarish',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '陳雅芳',
    handle: 'ya_fang_chen',
    avatar: 'https://readdy.ai/api/search-image?query=asian%20elderly%20woman%20warm%20smile%20portrait%20soft%20lighting%20neutral%20background&width=80&height=80&seq=10&orientation=squarish',
    content: '「從來沒想過助聽器可以這麼舒適！富聆聽的專家非常細心，幫我選了最適合的機型，現在跟家人聊天完全沒問題了。」',
  },
  {
    id: 2,
    name: '林建國',
    handle: 'lin_jian_guo',
    avatar: 'https://readdy.ai/api/search-image?query=asian%20middle%20aged%20man%20portrait%20smile%20soft%20lighting%20neutral%20background&width=80&height=80&seq=11&orientation=squarish',
    content: '「聽力退化後一直很抗拒戴助聽器，但富聆聽的隱形款式讓我完全沒有顧慮。服務專業，價格也很合理。」',
  },
  {
    id: 3,
    name: '王美玲',
    handle: 'mei_ling_wang',
    avatar: 'https://readdy.ai/api/search-image?query=asian%20elderly%20woman%20portrait%20gentle%20smile%20soft%20lighting%20neutral%20background&width=80&height=80&seq=12&orientation=squarish',
    content: '「 grandchildren 終於不用再對我大喊了！充電式設計超方便，每天睡前放上去就好，推薦給所有銀髮族。」',
  },
  {
    id: 4,
    name: '張志豪',
    handle: 'zhi_hao_zhang',
    avatar: 'https://readdy.ai/api/search-image?query=asian%20middle%20aged%20man%20portrait%20confident%20smile%20soft%20lighting%20neutral%20background&width=80&height=80&seq=13&orientation=squarish',
    content: '「工作會議中聽不清楚的困擾終於解決了。藍牙連線功能可以直接接電話，非常適合上班族。」',
  },
  {
    id: 5,
    name: '李淑芬',
    handle: 'shu_fen_li',
    avatar: 'https://readdy.ai/api/search-image?query=asian%20elderly%20woman%20portrait%20warm%20smile%20soft%20lighting%20neutral%20background&width=80&height=80&seq=14&orientation=squarish',
    content: '「門市環境很溫馨，不會有醫院的壓迫感。聽力師很耐心地幫我做檢測，解釋得清楚明白，讓人很安心。」',
  },
  {
    id: 6,
    name: '黃大衛',
    handle: 'david_huang',
    avatar: 'https://readdy.ai/api/search-image?query=asian%20elderly%20man%20portrait%20gentle%20smile%20soft%20lighting%20neutral%20background&width=80&height=80&seq=15&orientation=squarish',
    content: '「老婆一直說我電視開太大聲，來富聆聽檢測後才發現是聽力問題。現在戴了助聽器，生活品質提升很多。」',
  },
];

export const knowledgeArticles = [
  {
    id: 1,
    title: '聽力退化悄悄來，您注意到了嗎？',
    summary: '聽力損失往往在無聲無息中發生，許多人直到家人提醒才發現問題。了解早期徵兆，及早守護聽力健康。',
    category: '聽力保健',
    image: 'https://readdy.ai/api/search-image?query=elderly%20person%20checking%20hearing%20with%20audiologist%20in%20modern%20clinic%20warm%20lighting%20professional%20atmosphere%20green%20tones&width=600&height=400&seq=20&orientation=landscape',
  },
  {
    id: 2,
    title: '助聽器選購指南：找到最適合您的聽力夥伴',
    summary: '市面上助聽器種類繁多，從耳掛式到耳道式，從基本款到智能款，該怎麼選？本文帶您了解選購重點。',
    category: '助聽器保養',
    image: 'https://readdy.ai/api/search-image?query=various%20hearing%20aid%20devices%20arranged%20on%20soft%20white%20surface%20product%20comparison%20photography%20minimalist%20professional%20lighting&width=600&height=400&seq=21&orientation=landscape',
  },
  {
    id: 3,
    title: '噪音環境下的聽力防護',
    summary: '現代生活充斥著各種噪音，長期暴露可能造成不可逆的聽力損傷。學會正確的防護方法，保護您寶貴的聽力。',
    category: '噪音防護',
    image: 'https://readdy.ai/api/search-image?query=person%20wearing%20hearing%20protection%20earplugs%20in%20noisy%20environment%20safety%20health%20awareness%20soft%20professional%20photography&width=600&height=400&seq=22&orientation=landscape',
  },
  {
    id: 7,
    title: '耳鳴警訊：當耳朵開始嗡嗡響時該怎麼辦？',
    summary: '耳鳴不只是小困擾，可能是聽力問題的警訊。了解耳鳴的成因、影響與應對方式，別讓忽視造成遺憾。',
    category: '耳鳴專題',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20ear%20with%20tinnitus%20awareness%20concept%20soft%20abstract%20sound%20wave%20visualization%20around%20ear%20warm%20green%20tones%20professional%20medical%20illustration&width=600&height=400&seq=27&orientation=landscape',
  },
];